import s from "./styles.module.sass";
import checkSrc from "../../../../../../public/icons/checkRoseFilled.svg";
import Image from "next/image";

type AimsProps = {
	aims: Array<string>;
};

const Aims = ({ aims }: AimsProps) => {
	return (
		<section className={s.wrapper}>
			<h2>Что вы узнаете</h2>
			<ul className={s.aims}>
				{aims.map((item, index: number) => {
					return (
						<li key={index} className={s.aim}>
							<div className={s.checkIconWrapper}>
								<Image src={checkSrc} layout="fill" objectFit="contain" alt={item} />
							</div>
							<p className={s.aimText}>{item}</p>
						</li>
					);
				})}
			</ul>
		</section>
	);
};

export default Aims;
